import { render } from "./accountability.vue?vue&type=template&id=65b58393&scoped=true"
import script from "./accountability.vue?vue&type=script&lang=js"
export * from "./accountability.vue?vue&type=script&lang=js"

import "./accountability.vue?vue&type=style&index=0&id=65b58393&lang=css"
import "./accountability.vue?vue&type=style&index=1&id=65b58393&scoped=true&lang=css"
import "./accountability.vue?vue&type=style&index=2&id=65b58393&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65b58393"]])

export default __exports__